define(["require", "exports"], function (require, exports) {
    exports.videoblog = function () {
        for (var i = 0; i < document.querySelectorAll("td").length; i++) {
            if (!document.querySelectorAll("td")[i].classList.contains("tablec")) {
                document.querySelectorAll(" td")[i].style.border = "1px solid #ddd";
                document.querySelectorAll(" td")[i].style.textAlign = "center";
            }
        }
        for (var i = 0; i < document.querySelectorAll("figure").length; i++) {
            document.querySelectorAll("figure")[i].style.paddingBottom = "0px";
        }
        for (var i = 4; i < document.querySelectorAll("img").length - 3; i++) {
            document.querySelectorAll("img")[i].style.display = "block";
            document.querySelectorAll("img")[i].style.objectFit = "contain";
            document.querySelectorAll("img")[i].style.border = "none";
        }
    };
});
//tsconfig ten allowJs:true
//# sourceMappingURL=blog.js.map